import { createReducer, on } from '@ngrx/store';
import * as potentialCause from '../actions/potential-cause.actions';
import { PotentialCause } from '../../models/potential-cause.model';

export interface PotentialCauseState {
  potentialCause: PotentialCause[];
  error: any;
  loading: boolean;
}

export const initialState: PotentialCauseState = {
  potentialCause: [],
  error: null,
  loading: true,
};

export const potentialCauseReducer = createReducer(
  initialState,

  // Load actions
  on(potentialCause.loadPotentialCause, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(
    potentialCause.loadPotentialCauseSuccess,
    (state, { potentialCause: causes }) => ({
      ...state,
      potentialCause: causes,
      loading: false,
      error: null,
    })
  ),

  on(potentialCause.loadPotentialCauseFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Batch operations loading states
  on(
    potentialCause.deleteMultiplePotentialCauses,
    potentialCause.createMultiplePotentialCauses,
    potentialCause.updateMultiplePotentialCauses,
    (state) => ({
      ...state,
      loading: true,
      error: null,
    })
  ),

  on(
    potentialCause.deleteMultiplePotentialCausesSuccess,
    (state, { uids }) => ({
      ...state,
      potentialCause: state.potentialCause.filter(
        (cause) => !uids.includes(cause.uid!)
      ),
      loading: false,
      error: null,
    })
  ),

  on(
    potentialCause.createMultiplePotentialCausesSuccess,
    (state, { potentialCauses }) => ({
      ...state,
      potentialCause: [...state.potentialCause, ...potentialCauses],
      loading: false,
      error: null,
    })
  ),

  on(
    potentialCause.updateMultiplePotentialCausesSuccess,
    (state, { potentialCauses }) => ({
      ...state,
      potentialCause: state.potentialCause.map((cause) => {
        const updated = potentialCauses.find((pc) => pc.uid === cause.uid);
        return updated || cause;
      }),
      loading: false,
      error: null,
    })
  ),

  // Error handling
  on(
    potentialCause.deleteMultiplePotentialCausesFailure,
    potentialCause.createMultiplePotentialCausesFailure,
    potentialCause.updateMultiplePotentialCausesFailure,
    (state, { error }) => ({
      ...state,
      loading: false,
      error,
    })
  )
);
